import createTaskAction from '@esentai/core/ducks/tasks/createTaskAction';

import { UPDATE_KKM } from './consts/types';

export const updateKkm = createTaskAction(
  UPDATE_KKM,
  undefined,
  task => task.kkmId,
);
